import { useEffect, useState } from "react";
import { SelectForMember as SELECT } from "src/component/api/Dashboard/index";
import { LOGOUT } from "src/component/helper/constants";
export type ImageProps = {
  list: any;
  ProductMasterID: number;
  ProductType: string;
  FileList: string;
  ProductName: string;
};
const UseMemberDashboard = () => {
  const [groupAdmin, setGroupAdmin] = useState(0);
  const [user, setUser] = useState(0);
  const [totalUser, setTotalUser] = useState(0);
  const [totalSubscribers, setSubscribers] = useState(0);
  const [totalInvestBank, setTotalInvestBank] = useState(0);
  const [groupName, setGroupName] = useState("");
  const [totalExpence, setTotalExpence] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [memberNews, setDashboardNews] = useState("");
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [loanAmount, setLoanAmount] = useState(0);
  const [groupIncome, setGroupIncome] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [villageName, setVillageName] = useState("");
  const [productPath, setProductPath] = useState("");
  const [list, setList] = useState<ImageProps[]>();

  useEffect(() => {
    select();
  }, []);

  const select = async () => {
    const response = await SELECT();
    if (!response?.isAuthorized) LOGOUT();
    if (!response?.status) {
      return;
    }
    var data = JSON.parse(response?.data!);
    if (data && data.ProductPath) {
      const productPath = data.ProductPath;

      const fileList = productPath.map(
        (item: { FileList: any }) => item.FileList
      );

      setList(fileList);
      setProductPath(fileList.join(","));
    } else {
      setList([]);
      setProductPath("");
    }

    setGroupAdmin(data?.TotalGroupAdmin || 0);
    setTotalUser(data?.TotalUser || 0);
    setGroupName(data?.GroupName || "");
    setStartDate(data?.StartDate || "");
    setDashboardNews(data?.News || "");
    setUser(data?.TotalUser || 0);
    setTotalExpence(data?.TotalExpence || 0);
    setTotalInvestment(data?.TotalInvestment || 0);
    setTotalInvestBank(data?.TotalInvestmentWithBank || 0);
    setLoanAmount(data?.TotalLoan || 0);
    setGroupName(data?.GroupName || 0);
    setVillageName(data?.VillageName || 0);
    setStartDate(data?.StartDate || 0);
    setGroupIncome(data?.GroupIncome || 0);
    setRemainingAmount(data?.RemainingAmount || 0);
    setDashboardNews(data?.News || 0);
  };

  return {
    memberNews,
    groupAdmin,
    totalUser,
    groupName,
    startDate,
    totalSubscribers,
    totalInvestBank,
    user,
    totalExpence,
    totalInvestment,
    loanAmount,
    productPath,
    villageName,
    list,
    groupIncome,
    remainingAmount,
  };
};
export default UseMemberDashboard;
